import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, ListGroup } from 'reactstrap';
import Loading from '../Loading';
import MessageItem from './MessageItem';
import StartMessage from './New';
import { loadMessages, resetState, checkNew } from '../../../actions/messages';

const mapStateToProps = ({ messages }) => ({
  list: messages.list,
  count: messages.count,
  isLoaded: messages.isLoaded,
});
const mapDispatchToProps = dispatch => bindActionCreators({
  load: loadMessages,
  reset: resetState,
  check: checkNew,
}, dispatch);

class ChatDetails extends React.Component {
  constructor(props) {
    super(props);

    this.interval = 5; // sec

    this.onAddComplete = this.onAddComplete.bind(this);
    this.scroll = this.scroll.bind(this);
  }

  componentDidMount() {
    const { match, load, reset, check } = this.props;
    const chatId = +match.params.id;
    reset();
    load(chatId);

    this.intervalId = setInterval(() => check(chatId), this.interval * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  onAddComplete() {
    const { match, load, reset } = this.props;
    const chatId = +match.params.id;
    reset();
    load(chatId);
  }

  scroll() {
    window.setTimeout(() => this.messagesEnd.scrollIntoView({ block: 'end' }), 0);
  }

  render() {
    const { match, list, count, isLoaded, load } = this.props;
    const chatId = +match.params.id;

    return (
      <div key={chatId}>
        {!isLoaded && <Loading />}
        {isLoaded && count > list.length && (
          <Button
            color="primary"
            style={{ margin: '0 auto', display: 'block' }}
            onClick={() => load(chatId)}
            className="mrg-md fr"
          >Load more</Button>)}
        <div className="clear" />
        <ListGroup>{list.map((message, i) => (
          <li
            key={message.id}
            className="list-group-item message_item"
            ref={(el) => { // scroll to input if first portion:
              if (list.length > 10 && i === (list.length - 1) % 10) this.messagesEnd = el;
            }}
          >
            <MessageItem message={message} onAddComplete={this.onAddComplete} />
          </li>))}
        </ListGroup>
        <StartMessage chatId={chatId} onAddComplete={this.onAddComplete} />
        <div className="clear10" ref={(el) => { if (!this.messagesEnd) this.messagesEnd = el; }} />
        {isLoaded && this.scroll()}
      </div>
    );
  }
}

ChatDetails.propTypes = {
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  list: PropTypes.arrayOf(PropTypes.object).isRequired,
  count: PropTypes.number.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  load: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  check: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatDetails);



// WEBPACK FOOTER //
// ./src/views/_Chats/Messages/index.js